import { storyblokEditable } from "@storyblok/react";
const ImageFullWidth = ({ blok }) => {
  return (
    <div className="wrap">
      <div className="imagefullwidth-wrap inner-wrap" {...storyblokEditable(blok)}>
        <img src={blok.image.filename} alt={blok.image.alt} />
      </div>
    </div>
  );
};
export default ImageFullWidth;
